import {LOCALE_ID, NgModule} from '@angular/core';
import {CommonModule, registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { RootWebcallbackComponent } from './components/root-webcallback/root-webcallback.component';
import { PopUpSuccessDialog, WebcallbackComponent } from './pages-modules/webcallback/components/webcallback/webcallback.component';
import { AutoTabDirective } from './pages-modules/webcallback/directives/auto-tab-directive';
import { RoutingWCBModule } from './pages-modules/webcallback/routing-wcb.module';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NumberOnlyDirective } from './pages-modules/webcallback/directives/number-only.directive';

registerLocaleData(localeFr);

@NgModule({
  declarations: [
    RootWebcallbackComponent,
    WebcallbackComponent,
    AutoTabDirective,
    PopUpSuccessDialog,
    NumberOnlyDirective
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'fr-FR'}
  ],
  imports: [
    CommonModule,
    RoutingWCBModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule,
    BrowserAnimationsModule
  ],
  bootstrap: [RootWebcallbackComponent]
})
export class WebcallbackModule {
}
